'use client';

import Script from 'next/script';

import { TRANSCEND_LOAD_EVENT_NAME } from '@/modules/consent/constants';

type Props = {
  nonce: string;
};

const YEAR_IN_MINUTES = 60 * 24 * 365;

// set the data-css attribute to styles/transcend.css if you need to use the local css
// to tweak the styles. Otherwise leave it off so we get the styles from the dashboard.
export function InitTranscend({ nonce }: Props) {
  return (
    <Script
      id="transcend"
      nonce={nonce}
      src={process.env.NEXT_PUBLIC_AIRGAP_SRC}
      strategy="lazyOnload"
      data-cfasync="false"
      data-consent-expiry={YEAR_IN_MINUTES}
      data-ui-shadow-root="open"
      onLoad={(e: Event) => {
        /*
        The airgap SDK setConsent method has to be passed a real ui event (e.g. with isTrusted: true)
        Or it will not accept the consent. We've passed the event in the detail of the custom event so the
        handler in useConsentManager.ts can access it and it can be used to set the consent that we will get
        back from the server without having to have a ui event to set it.
        */
        window._TRANSCEND_LOAD_EVENT = e;
        window?.dispatchEvent(
          new CustomEvent(TRANSCEND_LOAD_EVENT_NAME, {
            detail: {
              event: e,
            },
          })
        );
      }}
      async
    />
  );
}
